__turbopack_context__.v({
  "blocksBackgroundColor": "ToggleInput-module-scss-module__GZrNGq__blocksBackgroundColor",
  "blocksFontColor": "ToggleInput-module-scss-module__GZrNGq__blocksFontColor",
  "inputContainer": "ToggleInput-module-scss-module__GZrNGq__inputContainer",
  "secondaryNavBackgroundColor": "ToggleInput-module-scss-module__GZrNGq__secondaryNavBackgroundColor",
  "switch": "ToggleInput-module-scss-module__GZrNGq__switch",
  "switchToggle": "ToggleInput-module-scss-module__GZrNGq__switchToggle",
  "themeBackgroundColor": "ToggleInput-module-scss-module__GZrNGq__themeBackgroundColor",
  "themeFontColor": "ToggleInput-module-scss-module__GZrNGq__themeFontColor",
  "themeFontFamily": "ToggleInput-module-scss-module__GZrNGq__themeFontFamily",
});
